import React from "react";
import "./Signature/sigCanvas.css";
import TextField from "@material-ui/core/TextField/TextField";
import {bindActionCreators} from "redux";
import {addVariableData, requestGetPlanningsData} from "../../actions";
import {connect} from "react-redux";
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import ImageUploader from "../Category/SocialFeed/ImageUploader";
import {uploadMediaStatic} from "../../api/api.form";

class FormulaireProfil extends React.Component{
    render() {
        const dyn_string  = this.props.t;
        let label = {};
        let errorProfil = {};
        let mobinaute = this.props.profil.mobinaute;

        console.log("Mobinaute");
        console.log(mobinaute);
        console.log(mobinaute.profilMedia);


        Object.entries(this.props.formData).forEach(([res]) => {
            if(this.props.formState[res+"error"]){
                label[res] = this.props.formState[res+"error"]
                errorProfil[res] = true;
            }else{
                label[res] = res;
                errorProfil[res] = false;
            }
        })

        let userSSO = (mobinaute.idConnectorSSO !== null);

        let profilPicture;

        const handleChangeProfilMedia = async (file) => {

            console.log('Fichier image sélectionné:', file);
            // Tu pourrais ici l’envoyer vers un backend
            // go upload


            //si c'est un fichier on l'upload, si c'est une url on la met dans selectedImageUrl
            if (file && file.type) {
                const responseUploadMediaStatic = await uploadMediaStatic(file);
                console.log('responseUploadMediaStatic:', responseUploadMediaStatic);
                if (responseUploadMediaStatic.success) {
                    //handle change
                    this.props.handleChange({
                        target: {
                            name: "profilMedia",
                            value: responseUploadMediaStatic.result.file_url
                        }
                    });
                } else {
                    console.error('Erreur lors de l\'upload de l\'image:', responseUploadMediaStatic.error);
                }
            }
            else {
                // Si c'est une URL, on la met directement dans le state
                this.props.handleChange({
                    target: {
                        name: "profilMedia",
                        value: file
                    }
                });
            }
        };

        const handleImageRemoved = () => {
            this.props.handleChange({
                target: {
                    name: "profilMedia",
                    value: ""
                }
            });
        };


        if(this.props.application.getApp.has_mobinaute_media === "1") {
            profilPicture = <ImageUploader id="profilMedia" name="profilMedia" onImageSelected={handleChangeProfilMedia}
                                           multiple={false}
                                           onImageRemoved={handleImageRemoved}
                                           defaultValue={mobinaute.profilMedia}
                                           label={dyn_string('profile_label_profil_picture')}
                                           positionPreview={"below"}/>
        }


        let display_password;
        if (parseInt(this.props.application.getApp.password_update) === 1 && !userSSO ) {
            display_password = (
                <>
                    <TextField
                        key={"ProfilForm_password"}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="password"
                        autoComplete="password"
                        name="password"
                        type="password"
                        placeholder={dyn_string('profile_placeholder_password')}
                        value={this.props.formState.value}
                        onChange={this.props.handleChange}
                        label={dyn_string('profile_label_password')}
                        error={errorProfil["pass"]}
                    />
                    <span style={{color: "#999999", fontStyle: "italic"}}>{dyn_string('profile_alert_msg_info_update_password')}</span>
                    <TextField
                        key={"ProfilForm_confirm_password"}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="confirm_password"
                        autoComplete="confirm_password"
                        name="confirm_password"
                        type="password"
                        placeholder={dyn_string('profile_placeholder_password')}
                        value={this.props.formState.value}
                        onChange={this.props.handleChange}
                        label={dyn_string('profile_label_confirm_pass')}
                        error={errorProfil["pass"]}
                    />
                </>
            );
        }

        return (
            <>

                {profilPicture && (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginBottom: "20px"
                }}>
                    {profilPicture}
                </div>
                )}


                <TextField
                    key={"ProfilForm_firstname"}
                    aria-required={true}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="firstname"
                    autoComplete="firstname"
                    name="firstname"
                    type="text"
                    placeholder={dyn_string('profile_label_fistname')}
                    defaultValue={mobinaute.firstname}
                    value={this.props.formState.value}
                    onChange={this.props.handleChange}
                    label={dyn_string('profile_label_fistname')}
                    error={errorProfil["firstname"]}
                    disabled={userSSO}
                />
                <TextField
                    key={"ProfilForm_lastname"}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="lastname"
                    autoComplete="lastname"
                    name="lastname"
                    type="text"
                    placeholder={dyn_string('profile_label_lastname')}
                    defaultValue={mobinaute.lastname}
                    value={this.props.formState.value}
                    onChange={this.props.handleChange}
                    label={dyn_string('profile_label_lastname')}
                    error={errorProfil["lastname"]}
                    disabled={userSSO}
                />
                <TextField
                    key={"ProfilForm_login"}
                    variant="outlined"
                    margin="normal"
                    required
                    disabled
                    fullWidth
                    name="login"
                    type="text"
                    placeholder={dyn_string('profile_label_login')}
                    defaultValue={mobinaute.login}
                    value={this.props.formState.value}
                    onChange={this.props.handleChange}
                    label={dyn_string('profile_placeholder_login')}
                    error={errorProfil["login"]}
                />

                <TextField
                    key={"ProfilForm_email"}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="Email"
                    autoComplete="Email"
                    defaultValue={mobinaute.mail}
                    name="Email"
                    type="mail"
                    placeholder={dyn_string('profile_placeholder_mail')}
                    value={this.props.formState.value}
                    onChange={this.props.handleChange}
                    label={label["Email"]?label["Email"]:dyn_string('profile_label_mail')}
                    error={errorProfil["Email"]}
                    disabled={userSSO}
                />
                {display_password}
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    variableStorage: state.variableStorage,
    styles: state.style,
    application: state.application,
    profil: state.profil,
    routes: state.routes
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            addVariableData,
            requestGetPlanningsData,
        },
        dispatch
    );

export default compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(FormulaireProfil);
